export default __webpack_public_path__ + "static/media/camBtnIcon.0de53a0b.svg";